module.exports = __webpack_public_path__ + "img/business.abef2661.jpg";